import React, { useState, useEffect, useCallback } from 'react';
import {
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  TextField,
} from '@mui/material';
import GradientButton from '../MUICustomButton/GradientButton';
import OutlineButton from '../MUICustomButton/OutlineButton';
import { styled } from '@mui/material/styles';
import Dialog from '@mui/material/Dialog';
import CloseIcon from '@mui/icons-material/Close';
interface CommonModalProps {
  open: boolean;
  onClose: () => void;
  title: string;
  onSave: (reportName: string) => void;
  isSaveFilter?: boolean;
  existingReportNames?: string[];
}
const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  '& .MuiDialogContent-root': {
    padding: theme.spacing(2),
  },
  '& .MuiDialogActions-root': {
    padding: theme.spacing(1),
  },
}));
const SaveReportModal: React.FC<CommonModalProps> = ({
  open,
  onClose,
  title,
  onSave,
  isSaveFilter = false,
  existingReportNames = [],
}) => {
  const [reportName, setReportName] = useState('');
  const [error, setError] = useState('');

  useEffect(() => {
    if (!open) {
      setReportName('');
      setError('');
    }
  }, [open]);

  const validateReportName = useCallback(
    (name: string): string => {
      if (name.trim() === '') {
        return 'Report name is required';
      }
      if (name.length > 50) {
        return 'Report name must not exceed 50 characters';
      }
      if (existingReportNames.includes(name)) {
        return 'Report name already exists';
      }
      return '';
    },
    [existingReportNames],
  );

  const handleSave = useCallback(() => {
    const validationError = validateReportName(reportName);
    if (validationError !== '') {
      setError(validationError);
      return;
    }

    onSave(reportName);
    onClose();
  }, [reportName, onSave, onClose, validateReportName]);

  const handleReportNameChange = useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      setReportName(e.target.value);
      setError('');
    },
    [],
  );

  return (
    <BootstrapDialog
      onClose={onClose}
      aria-labelledby="customized-dialog-title"
      open={open}
      PaperProps={{
        sx: {
          width: '450px',
          height: '230px',
        },
      }}
    >
      <DialogTitle
        sx={{
          m: 0,
          p: 2,
          color: '#3A3A3A',
          fontSize: '18px',
          fontWeight: '600',
        }}
        id="customized-dialog-title"
      >
        {title}
      </DialogTitle>
      <IconButton
        aria-label="close"
        onClick={onClose}
        sx={{
          position: 'absolute',
          right: 8,
          top: 8,
          color: (theme) => theme.palette.grey[500],
        }}
      >
        <CloseIcon />
      </IconButton>
      <DialogContent>
        {isSaveFilter && (
          <TextField
            fullWidth
            label="Report Name"
            value={reportName}
            onChange={handleReportNameChange}
            error={Boolean(error)}
            helperText={error}
            sx={{ mb: 2 }}
          />
        )}
      </DialogContent>
      <DialogActions sx={{ background: '#F9F9F9' }}>
        {/* <Button isGradient color="primary" label="Update" onClick={handleAssigneeClose} /> */}
        <OutlineButton color="gray" onClick={onClose} width="120px">
          Cancel
        </OutlineButton>
        <GradientButton color="red" width="130px" onClick={handleSave}>
          Save
        </GradientButton>
      </DialogActions>
    </BootstrapDialog>
  );
};

export default SaveReportModal;
